// Duplicated from ab-common
function hasOwnProperty(o, key) {
  return Object.prototype.hasOwnProperty.call(o, key);
}
function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (hasOwnProperty(obj, key)) {
      result[key] = obj[key];
    }
  }
  return result;
}
export default pick;